import * as XLSX from 'xlsx';

type ExportFormat = 'csv' | 'xlsx';

interface ExportColumn<T> {
    key: keyof T | string;
    label: string;
    render?: (value: any, record: T) => string | number;
}

export const exportTableData = <T extends Record<string, any>>(
    data: T[],
    columns: ExportColumn<T>[],
    fileName: string,
    format: ExportFormat = 'xlsx',
) => {
    const rows = data.map((record) => {
        const row: Record<string, string | number> = {};
        columns.forEach((col) => {
            const value = record[col.key as keyof T];
            row[col.label] = col.render
                ? col.render(value, record)
                : (value ?? '-');
        });
        return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const colWidths = columns.map((col) => ({
        wch: Math.max(col.label.length, 15),
    }));
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    if (format === 'csv') {
        XLSX.writeFile(workbook, `${fileName}.csv`, { bookType: 'csv' });
    } else {
        XLSX.writeFile(workbook, `${fileName}.xlsx`, { bookType: 'xlsx' });
    }
};
